export default "__VITE_ASSET__0ab38bdd__"